import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface SnackbarProps {
    message: string;
    open: boolean;
    onClose: () => void;
}

const CustomSnackbar: React.FC<SnackbarProps> = ({ message, open, onClose }) => {
    const severity = typeof message === 'string' && message.includes('Error') ? 'error' : 'success';

    return (
        <Snackbar open={open} autoHideDuration={3000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
                {message || 'No message provided'}
            </Alert>
        </Snackbar>
    );
};

export default CustomSnackbar;
